import React from 'react';
import PropTypes from 'prop-types';
import mediator, { ACTIONS } from 'mediator';
import classnames from 'classnames';
import metrics from 'lib/common/metrics';
import getAvailablePrices from 'lib/pricing/getAvailablePrices';
import { toCurrency } from 'services/Pricer';
import features from 'lib/common/features';

const PriceKey = React.createClass({
  propTypes: {
    prices: PropTypes.arrayOf(PropTypes.object).isRequired,
    screenZoneData: PropTypes.object,
    zonesByLevel: PropTypes.object,
    isAvailable: PropTypes.bool.isRequired // eslint-disable-line react/no-unused-prop-types
  },
  getDefaultProps: function() {
    return {
      prices: []
    };
  },
  getInitialState: function() {
    return {
      selectedPrices: null,
      pricesToDisplay: getAvailablePrices(this.props.prices),
      selectedBoxLimit: []
    };
  },
  componentWillMount: function() {
    mediator.subscribe(ACTIONS.LEVEL_SELECTED, this.filterByLevel);
    mediator.subscribe(ACTIONS.SCREEN_FILTER_SELECTED, this.filterByZones);
    mediator.subscribe(
      ACTIONS.CURRENT_BOX_MINIMUM_SELECTED,
      this.setSelectedBoxLimit
    );
  },
  componentWillUnmount: function() {
    mediator.unsubscribe(ACTIONS.LEVEL_SELECTED, this.filterByLevel);
    mediator.unsubscribe(ACTIONS.SCREEN_FILTER_SELECTED, this.filterByZones);
    mediator.unsubscribe(
      ACTIONS.CURRENT_BOX_MINIMUM_SELECTED,
      this.setSelectedBoxLimit
    );
  },
  componentDidUpdate: function() {
    let selectedPrices = this.state.selectedPrices;
    let selectedLimit = this.state.selectedBoxLimit;
    let selected = [];

    if (Array.isArray(selectedPrices) && selectedPrices !== null) {
      let priceTypeZones = selectedPrices.map(x => parseInt(x.zone_no, 10));

      if (selectedLimit.length && selectedPrices.length) {
        selected = selectedLimit.filter(x => priceTypeZones.includes(x));
      } else {
        selected = [...selectedLimit, ...priceTypeZones];
      }

      mediator.publish(ACTIONS.PRICE_FILTER_SELECTED, {
        selected: selected
      });
    }
  },
  resetState: function() {
    metrics.action('Filtered prices', 'Any price');
    this.setState({
      selectedPrices: []
    });
  },
  resetSelectedPrices: function() {
    this.setState({
      pricesToDisplay: getAvailablePrices(this.props.prices)
    });
  },
  setSelectedBoxLimit: function(payload) {
    this.setState({
      selectedBoxLimit: payload.selectedZones
    });
  },
  filterByLevel: function(selectedLevel) {
    let { prices, zonesByLevel } = this.props;
    let zonesForSelectedLevel = zonesByLevel && zonesByLevel[selectedLevel];
    if (zonesForSelectedLevel) {
      this.setState({
        selectedPrices: null,
        pricesToDisplay: getAvailablePrices(prices, zonesForSelectedLevel)
      });
    } else {
      this.resetSelectedPrices();
    }
  },
  filterByZones: function(data) {
    let { prices, screenZoneData } = this.props;
    if (data && screenZoneData) {
      let selectedZones = screenZoneData[data.selected].zones;
      this.setState({
        pricesToDisplay: getAvailablePrices(prices, selectedZones)
      });
    } else {
      this.resetSelectedPrices();
    }
  },
  onChange: function(e) {
    const val = e.target.value;
    if (val) {
      let prices = this.props.prices.filter(x => x.price_with_fee == val);
      metrics.action('Filtered prices', toCurrency(val));

      this.setState({
        selectedPrices: prices
      });

      if (features.isEnabled('podSeats')) {
        mediator.publish(ACTIONS.CURRENT_PRICE_ZONES_SELECTED, {
          selected: prices.map(x => parseInt(x.zone_no, 10))
        });
      }
    } else {
      this.resetState();

      if (features.isEnabled('podSeats')) {
        mediator.publish(ACTIONS.CURRENT_PRICE_ZONES_SELECTED, {
          selected: []
        });
      }
    }
  },
  render: function() {
    let pricesToDisplay = this.state.pricesToDisplay;
    return (
      <div
        className={classnames({
          'syos-price-filter': true,
          'syos-price-filter--loading': !pricesToDisplay.length
        })}
      >
        <label className="syos-price-filter__label">
          <span className="syos-price-filter__label-text">
            {features.getOption('priceFees', 'filterByPriceFeesLabel')}
          </span>
          <select
            className="syos-price-filter__select"
            onChange={this.onChange}
          >
            <optgroup label="Filter by price">
              <option value="">Any price</option>
              {pricesToDisplay.map((item, idx) => {
                return (
                  <option
                    key={idx}
                    value={item.priceData.price_with_fee}
                    disabled={item.isDisabled}
                  >
                    {toCurrency(item.priceData.price_with_fee)}
                  </option>
                );
              })}
            </optgroup>
          </select>
        </label>
      </div>
    );
  }
});

export default PriceKey;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/PriceKey.js